import { render, staticRenderFns } from "./swpReferences.vue?vue&type=template&id=20f5fd62"
import script from "./swpReferences.vue?vue&type=script&lang=js"
export * from "./swpReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f5fd62')) {
      api.createRecord('20f5fd62', component.options)
    } else {
      api.reload('20f5fd62', component.options)
    }
    module.hot.accept("./swpReferences.vue?vue&type=template&id=20f5fd62", function () {
      api.rerender('20f5fd62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/swpReferences.vue"
export default component.exports